// src/components/DashboardCustomer/SimulationComponent.js
import { useState } from 'react';
import { Card, CardContent, Typography, Button } from '@mui/material';

function SimulationComponent() {
  const [count, setCount] = useState(0);

  const handleSimulate = () => {
    // Basit bir simülasyon: sayacı artır
    setCount(count + 1);
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Simülasyon
        </Typography>
        <Typography variant="body1">Simülasyon sayısı: {count}</Typography>
        <Button variant="contained" color="secondary" onClick={handleSimulate}>
          Simüle Et
        </Button>
      </CardContent>
    </Card>
  );
}

export default SimulationComponent;
